import { render } from "./SinglePaint.vue?vue&type=template&id=bb27391e&scoped=true"
import script from "./SinglePaint.vue?vue&type=script&lang=js"
export * from "./SinglePaint.vue?vue&type=script&lang=js"

import "./SinglePaint.vue?vue&type=style&index=0&id=bb27391e&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb27391e"]])

export default __exports__